import { getAccountPlatformType } from "@/entities/accounts/libs/account-platform";
import type {
  AccountPlatformType,
  AccountType,
} from "../../../shared/types/accounts";

export const getPreviewAccounts = (
  accounts: AccountType[],
  selectedPlatform: AccountPlatformType | "LINKED"
) =>
  selectedPlatform === "LINKED"
    ? accounts
    : accounts.filter(
        (account) => getAccountPlatformType(account) === selectedPlatform
      );
